import React from 'react';

const IconList = ({ onClick, color = '#141029' }) => (

  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24" onClick={onClick}>
    <defs>
      <path id="prefix__alist" d="M20 16c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1s.448-1 1-1h12zM4 16c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm16-5c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1s.448-1 1-1h12zM4 11c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm16-5c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1s.448-1 1-1h12zM4 6c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" />
      <mask id="prefix__blist" fill="#fff">
        <use xlinkHref="#prefix__alist" />
      </mask>
      <use fill={color} xlinkHref="#prefix__alist" />
      <g mask="url(#prefix__blist)">
        <path d="M0 0H24V24H0z" />
      </g>
    </g>
  </svg>

);

export default IconList;
